import React, { useState, useEffect, } from "react";
import { useTheme } from '~/contexts/ThemeContext'
import { useCart } from '~/contexts/CartContext'
import Flink from '~/components/shared/flink'
import useAnalytics from '~/utils/analytics'
import { imgSize, notBlank, jnstyls, deShopId, reShopId } from '~/utils/helpers'

import * as styles from "~/styles/panels/cart-upsell.module.scss"


const CartUpsell = ({ lastProd, cartLines, groupTitle='People Also Bought'}) => {
  const { setFreeze, analytics, setAnalytics, quick } = useTheme()
  const { cart, cartRecs, setCartOpen } = useCart()
  const { elev_select, ga_tile_click } = useAnalytics()
  
  const [recProds, setRecProds] = useState([]) 

  const handleLink = (product, tile_ind) => {
    setFreeze(false)
    setCartOpen(false)
    setAnalytics({...analytics, list: 'cart recommendation'})
    ga_tile_click(product, tile_ind, 'cart recommendation')
    elev_select(product, tile_ind, 'cart recommendation')
  }

  const pick_img = (item) => {
    let image = item.image
    if (!image && item.media && item.media.find(x => x.type === 'IMAGE')) {
      image = item.media.find(x => x.flat) ? item.media.find(x => x.flat) : item.media.find(x => x.type === 'IMAGE')
      image = image.src
    }

    return imgSize(image,500)
  }

  const checkRecs = (item) => {
    const recs_arr = cartRecs || []
    const all_shop_ids = cart.lines?.edges?.length > 0 ? cart.lines.edges.map(x => deShopId(x.node.merchandise.product.id)) : []
    let other_recs = cartRecs.filter( x => reShopId(x.shop_id) !== item.merchandise.product.id).flatMap(x => x.recs)
    other_recs = other_recs.filter(x => !all_shop_ids.includes(x.shop_id))

    let rec_prods = recs_arr.find( x => reShopId(x.shop_id) === item.merchandise.product.id) || {}
    if (rec_prods?.recs?.length > 0) {
      rec_prods = JSON.parse(JSON.stringify(rec_prods))
      let recs_arr = (rec_prods && rec_prods.hasOwnProperty('recs')) ? rec_prods.recs : []
      recs_arr = recs_arr.filter(x => !all_shop_ids.includes(x.shop_id))

      if (recs_arr.length < 12) {
        const recs_ids = recs_arr.map(x => x.mid)
        other_recs = other_recs.filter(x => !recs_ids.includes(x.mid))
        recs_arr = recs_arr.concat(other_recs).slice(0,12)
      }
      rec_prods.recs = recs_arr
    }
    return rec_prods
  }

  const recsOutfits = () => {
    let rec_prods = checkRecs(lastProd)

    if (cartLines.length > 1 && !(rec_prods.recs?.length > 0)) {
      rec_prods = checkRecs(cartLines[1])
    }
    setRecProds(rec_prods.recs)
  }

  useEffect(() => {
    if (!lastProd) return
    recsOutfits()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastProd])

  return (
    <>
      {recProds?.length > 0 ? (
        <div className={jnstyls([styles.upsell])} c-ups=''>
          <div className={styles.recs_head}>
            <div className={styles.title}>
              {groupTitle}
            </div>
          </div>

          <div className={styles.recs}>
            {recProds.map( (item, index) => 
              <Flink 
                key={item.handle} 
                href={`/products/${item.handle}`}
                className={styles.rec}
                onClick={(e)=>{handleLink(item, index)}}
              >
                <div className={styles.rec_image}>
                  <img 
                    className={styles.img} 
                    src={pick_img(item)}
                    alt={`Buck Mason ${item.title}`} 
                    height="300" 
                    width="200" 
                  />
                </div>
                <div className={styles.rec_content}>
                  {(notBlank(item.clr) && notBlank(item.product_line?.name)) ? (
                    <>
                      <div className={styles.title_price}>
                        <div className={styles.title}>
                          {item.product_line.name}
                        </div>
                        <div className={styles.price}>
                          ${item.first_product_price}
                        </div>
                      </div>
                      <div className={styles.color}>
                        {item.clr}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={styles.title}>
                        {(notBlank(item.product_line?.name) && notBlank(item.color)) ? item.product_line.name : item.title}
                      </div>
                      {notBlank(item.color) && (
                        <div className={styles.color}>
                          {item.color}
                        </div>
                      )}
                      <div className={styles.price}>
                        ${item.first_product_price}
                      </div>
                    </>
                  )}
                </div>
              </Flink>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}


export default CartUpsell



